export enum ProductNumber {
  Fi2Xml = 'FI2XML'
}
